import React, { Fragment } from 'react';
import Link from 'gatsby-link';
import Img from "gatsby-image";
import Slider from "react-slick";
import Absorbed from '../static/images/absorbed_in.png';
import Actionable from '../static/images/Actionable.svg';
import Configurable from '../static/images/confiqurable.svg';
import Contextual from '../static/images/contextual.svg';
import Extensible from '../static/images/extensible.svg';
import Intelligent from '../static/images/intelligent.svg';
import Realtime from '../static/images/realtime.svg';
import Ccd from '../static/images/clients/ccd.png';
import AndroidBadge from '../static/images/badges/google-play-badge.png';
import Manage from '../static/images/ic_manage_monitor.svg'
import Empower from '../static/images/ic_empower_engage.svg';
import Predict from '../static/images/ic_predict_prevent.svg';


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from './landing.module.scss';
import { height } from 'window-size';

const settings = {
  dots: false,
  autoplay: true,
  infinite: true,
  speed: 400,
  slidesToShow: 1,
  slidesToScroll: 1
};

const LandingPage = () => (
  <Fragment>
    <div className={styles.landing__two__column__container}>
      <div className={styles.landing__two__column__container__box}>
        <Slider {...settings} className={styles.slick__slider}>
          <div>
            <div className={styles.landing__features__normal__subtitle}>Organize field operations and  
            <span className={styles.landing__features__highlighted__subtitle}> increase efficiency</span>.
            </div>
            <br/><br/>
            <div className={styles.landing__features__highlighted__title}>UpTyme</div>
            <div className={styles.landing__features__normal__title}>Intelligent Field Automation</div>
            <div className={styles.btn__wrapper}>
              <Link to="/contactus" className={styles['landing__btn']}>
                <span>Want a trial?</span>
              </Link>
            </div>
          </div>
          <div>
            <div className={styles.landing__features__normal__subtitle}>A 
            <span className={styles.landing__features__highlighted__subtitle}> cloud based</span> mobility tool designed from the ground up for organizations with field or store execution teams.
            </div>
            <br/><br/>
            <div className={styles.landing__features__highlighted__title}>UpTyme</div>
            <div className={styles.landing__features__normal__title}>Intelligent Field Automation</div>
            <div className={styles.btn__wrapper}>
              <Link to="/contactus" className={styles['landing__btn']}>
                <span>Want a trial?</span>
              </Link>
            </div>
          </div>
          <div>
            <div className={styles.landing__features__normal__subtitle}>
            <span className={styles.landing__features__highlighted__subtitle}>Analytical insights</span> and consulting designed to drive organizational <span className={styles.landing__features__highlighted__subtitle}> optimization </span> and <span className={styles.landing__features__highlighted__subtitle}>visibility</span>.
            </div>
            <br/><br/>
            <div className={styles.landing__features__highlighted__title}>UpTyme</div>
            <div className={styles.landing__features__normal__title}>Intelligent Field Automation</div>
            <div className={styles.btn__wrapper}>
              <Link to="/contactus" className={styles['landing__btn']}>
                <span>Want a trial?</span>
              </Link>
            </div>
          </div>
        </Slider>
      </div>
      <div className={styles.landing__two__column__container__box}>
        <img src={Absorbed} className={styles.Absorbed}/>
      </div>
    </div>
    <div className={styles.landing__three__column__container}>
      <div className={styles.landing__two__column__container__fullrow}>
        <div className={styles.landing__features__highlighted__title__center}>UpTyme</div>
        <div className={styles.landing__features__normal__subtitle_center}>A seamless AI-enabled field automation platform that ensures continuous business uptime</div>
      </div>
      <div className={styles.landing__three__column__container__box_for_overview_with_shadow_1}>
        <img src={Manage} className={styles.Absorbed_head}/>
        <div style={{height:"100%"}}>
          <div className={styles.landing__features__highlighted__text_center_key}>Manage and monitor</div>
          <br/>
          <div className={styles.landing__features__normal__text_center_key}>Our cloud based platform allows users to create and manage tasks from anywhere using any device.</div>
        </div>
      </div>
      <div className={styles.landing__three__column__container__box_for_overview_with_shadow_2}>
        <img src={Empower} className={styles.Absorbed_head}/>
        <div style={{height:"100%"}}>
          <div className={styles.landing__features__highlighted__text_center_key}>Empower and engage</div>
          <br/>
          <div className={styles.landing__features__normal__text_center_key}>From knowledge sharing to real-time tracking, our intuitive mobile app works on any device. Data driven algorithms ensure optimal task assignment.</div>
        </div>
      </div>
      <div className={styles.landing__three__column__container__box_for_overview_with_shadow_3}>
        <img src={Predict} className={styles.Absorbed_head}/>
        <div style={{height:"100%"}}>
          <div className={styles.landing__features__highlighted__text_center_key}>Predict and prevent</div>
          <br/>
          <div className={styles.landing__features__normal__text_center_key}>Seamless IoT integration and machine learning to efficiently predict failures</div>
        </div>
      </div>
    </div>
    <div className={styles.landing__three__column__container}>
      <div className={styles.landing__two__column__container__fullrow}>
        <div className={styles.landing__features__highlighted__title__center}>Key Principles</div>
        {/* <div className={styles.landing__features__normal__subtitle_center}>Under the hood features</div> */}
      </div>
      <div className={styles.landing__three__column__container__box_with_shadow}>
        <img src={Intelligent} className={styles.Absorbed_key}/>
        <div style={{height:"100%"}}>
          <div className={styles.landing__features__highlighted__text_center}>Intelligent</div>
          <br/>
          <div className={styles.landing__features__normal__text_center}>Algo driven intelligent recommendations on scheduling and assignment</div>
        </div>
      </div>
      <div className={styles.landing__three__column__container__box_with_shadow}>
        <img src={Actionable} className={styles.Absorbed_key}/>
        <div style={{height:"100%"}}>
          <div className={styles.landing__features__highlighted__text_center}>Actionable</div>
          <br/>
          <div className={styles.landing__features__normal__text_center}>Realtime reporting & analytics that churn out insights on historical trends and predictions</div>
        </div>
      </div>
      <div className={styles.landing__three__column__container__box_with_shadow}>
        <img src={Configurable} className={styles.Absorbed_key}/>
        <div style={{height:"100%"}}>
          <div className={styles.landing__features__highlighted__text_center}>Configurable</div>
          <br/>
          <div className={styles.landing__features__normal__text_center}>Workflows are intuitively configurable using simple drag-and-drops or filters</div>
        </div>
      </div>
      <div className={styles.landing__three__column__container__box_with_shadow}>
        <img src={Contextual} className={styles.Absorbed_key}/>
        <div style={{height:"100%"}}>
          <div className={styles.landing__features__highlighted__text_center}>Contextual</div>
          <br/>
          <div className={styles.landing__features__normal__text_center}>Designed to be field user friendly; comes with multi-lingual support.</div>
        </div>
      </div>
      <div className={styles.landing__three__column__container__box_with_shadow}>
        <img src={Extensible} className={styles.Absorbed_key}/>
        <div style={{height:"100%"}}>
          <div className={styles.landing__features__highlighted__text_center}>
            Extensible
          </div>
          <br/>
          <div className={styles.landing__features__normal__text_center}>Plug-and-play integrations with existing CRM/ticket management systems.</div>
        </div>
      </div>
      <div className={styles.landing__three__column__container__box_with_shadow}>
        <img src={Realtime} className={styles.Absorbed_key}/>
        <div style={{height:"100%"}}>
          <div className={styles.landing__features__highlighted__text_center}>Real-time</div>
          <br/>
          <div className={styles.landing__features__normal__text_center}>Smart, location driven real-time team tracking and ticket closure</div>
        </div>
      </div>
    </div>
    <br/>
    <div className={styles.landing_client}>
      <div>
        <div className={styles.landing__features__highlighted__title__center}>Our Clients</div>
        <br/>
        <a href="https://www.cafecoffeeday.com/" target="_blank"><img src={Ccd} className={styles.Absorbed_client}/></a>
      </div>
    </div>
    <br/><br/>
    <div className={styles.landing__two__column__container}>
      <div className={styles.landing__hero__container__heading}>
        Get started today
      </div>
      <div className={styles.btn__wrapper}>
        <Link to="/contactus" className={styles['landing__btn']}>
          <span>Request Demo</span>
        </Link>
      </div>
    </div>
    {/* <div className={styles.landing__two__column_badge}>
      <div className={styles.landing__two__column__badge__container__box}>
        <a href="https://play.google.com/store/apps/details?id=in.walkin.servicex.ccd" target="_blank"><img src={AndroidBadge} height = "30px"/></a>
      </div>
    </div> */}
  </Fragment>
);

export default LandingPage;



// WEBPACK FOOTER //
// ./src/pages/landing.js